// Single source of truth for brand-level SEO values so they don't drift
// between index.html, useDocumentMeta, and the JSON-LD blocks.
export const SITE_URL = "https://latifgeneral.store";
export const SITE_NAME = "Latif General Store";
export const PRIMARY_KEYWORDS =
  "Latif General Store, Latif Store, Latif General, toys Pakistan, hosiery Pakistan, garments Pakistan, wholesale store Pakistan, retail store Pakistan";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/brand/logo-dark.png`;
